export const getFPS = () =>
  new Promise((resolve) =>
    requestAnimationFrame((t1) =>
      requestAnimationFrame((t2) => resolve(1000 / (t2 - t1)))
    )
  );

const re = /([0-9]+|([A-Z][a-z]+)|[a-z]+|([A-Z]+)(?![a-z]))/g;
export const kebabCase = (str) =>
  (String(str ?? "").match(re) || []).map((x) => x.toLowerCase()).join("-");

export const wait = (ms) => new Promise((r) => setTimeout(r, ms));

export const capitalize = (string) =>
  string.charAt(0).toUpperCase() + string.slice(1);

export const range = (start, end, increment) => {
  // if the end is not defined...
  const isEndDef = typeof end !== "undefined";
  // ...the first argument should be the end of the range...
  end = isEndDef ? end : start;
  // ...and 0 should be the start
  start = isEndDef ? start : 0;

  // if the increment is not defined, we could need a +1 or -1
  // depending on whether we are going up or down
  if (typeof increment === "undefined") {
    increment = Math.sign(end - start);
  }

  // calculating the lenght of the array, which has always to be positive
  const length = Math.abs((end - start) / (increment || 1));

  // In order to return the right result, we need to create a new array
  // with the calculated length and fill it with the items starting from
  // the start value + the value of increment.
  const { result } = Array.from({ length }).reduce(
    ({ result, current }) => ({
      // append the current value to the result array
      result: [...result, current],
      // adding the increment to the current item
      // to be used in the next iteration
      current: current + increment,
    }),
    { current: start, result: [] }
  );

  return result;
};

export const debounce = (func, delay, { leading } = {}) => {
  let timerId;

  return (...args) => {
    if (!timerId && leading) {
      func(...args);
    }
    clearTimeout(timerId);

    timerId = setTimeout(() => func(...args), delay);
  };
};

/**
 * Loops value with modulo 2 ways around
 * @param {*} value
 * @param {*} limit
 * @returns
 */
export function loopValue(value, limit) {
  return ((value % limit) + limit) % limit;
}

export const updateItemInArray = (array, id, key, value) => {
  const index = array.findIndex((item) => item.id === id);
  if (index === -1) {
    return [...array, { id, [key]: value }];
  }

  // Only update if the value is different to avoid unnecessary re-renders
  if (array[index][key] === value) {
    return array;
  }

  return array.map((item) =>
    item.id === id ? { ...item, [key]: value } : item
  );
};
